import { Extension } from '@tiptap/core';
import { SuggestionPluginKey } from '@tiptap/suggestion';

const EnterToSend = (setText: (text: string) => void) => Extension.create({
  name: 'enterKeyHandler',
  priority: 1000,
  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        // 1. Check if the suggestion plugin is active
        const suggestionState = SuggestionPluginKey.getState(editor.state);

        // 2. If active, return false to let the Mention plugin handle the key
        if (suggestionState?.active) {
          return false;
        }

        // 3. Otherwise, proceed with send logic
        if (!editor.isEmpty) { // Optional: prevent sending empty messages
          setText(editor.getHTML());
          editor.commands.clearContent();
        }

        return true;
      },
    }
  },
});

export default EnterToSend;